import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
const useDeviceType = () => {
  const $ = _c(2);
  const [isDesktop, setIsDesktop] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const updateDeviceType = () => {
        setIsDesktop(window.innerWidth >= 1024);
      };
      updateDeviceType();
      window.addEventListener("resize", updateDeviceType);
      return () => {
        window.removeEventListener("resize", updateDeviceType);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isDesktop;
};
export default useDeviceType;